<div class="card">
    <div class="card-header">
        <span class="material-icons">sell</span>
        <h2 class="card-title">Sales in Progress</h2>
    </div>
    <div class="card-body">
        <ul class="list-group list-group-flush sales-in-progress-list">
            @for (sale of sales; track sale.id) {
                <li class="list-group-item" [routerLink]="['/quotes', sale.id]">
                    @if (sale.url) {
                        <img [src]="sale.url" [alt]="sale.model" />
                    }
                    @if (!sale.url) {
                        <p class="pallette" [class.bordered]="(sale.exteriorColor && (sale.exteriorColor.toLowerCase() === 'white'))" [style.backgroundColor]="sale.exteriorColor ? sale.exteriorColor.toLowerCase() : null">&nbsp;</p>
                    }
                    <section class="text-truncate">
                        <h5>{{sale.year}} {{sale.make}} {{sale.model}} - {{sale.buyer}}</h5>
                        <p class="subtitle">{{sale.type}} | {{sale.stock}}</p>
                    </section>
                    <p>{{when(sale.saleDate)}}</p>
                </li>
            }
            @empty {
                <li class="list-group-item">No pending sales at this time.</li>
            }
        </ul>
    </div>
</div>